import { render } from "./ticker.vue?vue&type=template&id=178ec89b"
import script from "./ticker.vue?vue&type=script&lang=js"
export * from "./ticker.vue?vue&type=script&lang=js"

import "./ticker.vue?vue&type=style&index=0&id=178ec89b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__